import { render } from "./SupplierDetails.vue?vue&type=template&id=47b9252d&ts=true"
import script from "./SupplierDetails.vue?vue&type=script&lang=ts"
export * from "./SupplierDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__